export const tenementTypes = [
    {
      "label": "PROSPECTING LICENCE",
      "value": "PROSPECTING LICENCE"
    },
    {
      "label": "TAILINGS AREA",
      "value": "TAILINGS AREA"
    },
    {
      "label": "MISCELLANEOUS LICENCE",
      "value": "MISCELLANEOUS LICENCE"
    },
    {
      "label": "CHRISTMAS ISLAND MISCELLANEOUS LICENCE",
      "value": "CHRISTMAS ISLAND MISCELLANEOUS LICENCE"
    },
    {
      "label": "MINERAL CLAIM",
      "value": "MINERAL CLAIM"
    },
    {
      "label": "EXPLORATION LICENCE OFFSHORE",
      "value": "EXPLORATION LICENCE OFFSHORE"
    },
    {
      "label": "COMMONWEALTH EXPLORATION LICENCE",
      "value": "COMMONWEALTH EXPLORATION LICENCE"
    },
    {
      "label": "GENERAL PURPOSE LEASE S.A.",
      "value": "GENERAL PURPOSE LEASE S.A."
    },
    {
      "label": "QUARRYING AREA",
      "value": "QUARRYING AREA"
    },
    {
      "label": "MINING LEASE",
      "value": "MINING LEASE"
    },
    {
      "label": "MINING LEASE S.A.",
      "value": "MINING LEASE S.A."
    },
    {
      "label": "COAL MINING LEASE",
      "value": "COAL MINING LEASE"
    },
    {
      "label": "DREDGING SLUICING",
      "value": "DREDGING SLUICING"
    },
    {
      "label": "REWARD LEASE",
      "value": "REWARD LEASE"
    },
    {
      "label": "POULTRY FARM",
      "value": "POULTRY FARM"
    },
    {
      "label": "DREDGING LEASE",
      "value": "DREDGING LEASE"
    },
    {
      "label": "CHRISTMAS ISLAND MINING LEASE",
      "value": "CHRISTMAS ISLAND MINING LEASE"
    },
    {
      "label": "LICENCE TO TREAT TAILINGS",
      "value": "LICENCE TO TREAT TAILINGS"
    },
    {
      "label": "RETENTION LICENCE",
      "value": "RETENTION LICENCE"
    },
    {
      "label": "PROSPECTING AREA",
      "value": "PROSPECTING AREA"
    },
    {
      "label": "EXPLORATION LICENCE",
      "value": "EXPLORATION LICENCE"
    },
    {
      "label": "MINERAL LEASE",
      "value": "MINERAL LEASE"
    },
    {
      "label": "STREAM WATER RIGHT",
      "value": "STREAM WATER RIGHT"
    },
    {
      "label": "TEMPORARY RESERVE",
      "value": "TEMPORARY RESERVE"
    },
    {
      "label": "MISCELLANEOUS LICENSE S.A.",
      "value": "MISCELLANEOUS LICENSE S.A."
    },
    {
      "label": "RESIDENTIAL AREA",
      "value": "RESIDENTIAL AREA"
    },
    {
      "label": "CHRISTMAS ISLAND GENERAL PURPOSE LEASE",
      "value": "CHRISTMAS ISLAND GENERAL PURPOSE LEASE"
    },
    {
      "label": "WELL SITE",
      "value": "WELL SITE"
    },
    {
      "label": "DREDGING CLAIM",
      "value": "DREDGING CLAIM"
    },
    {
      "label": "QUARTZ CLAIM",
      "value": "QUARTZ CLAIM"
    },
    {
      "label": "RESIDENCE LEASE",
      "value": "RESIDENCE LEASE"
    },
    {
      "label": "WASHING AREA",
      "value": "WASHING AREA"
    },
    {
      "label": "MINERAL LEASE S.A.",
      "value": "MINERAL LEASE S.A."
    },
    {
      "label": "COCOS (KEELING) ISLAND EXPLORATION LICENCE",
      "value": "COCOS (KEELING) ISLAND EXPLORATION LICENCE"
    },
    {
      "label": "WATER LEASE",
      "value": "WATER LEASE"
    },
    {
      "label": "WATER RIGHT",
      "value": "WATER RIGHT"
    },
    {
      "label": "ALLUVIAL CLAIM",
      "value": "ALLUVIAL CLAIM"
    },
    {
      "label": "MACHINERY AREA",
      "value": "MACHINERY AREA"
    },
    {
      "label": "REWARD CLAIM",
      "value": "REWARD CLAIM"
    },
    {
      "label": "MINERALS PRODUCTION LICENCE",
      "value": "MINERALS PRODUCTION LICENCE"
    },
    {
      "label": "TRAMWAY LEASE",
      "value": "TRAMWAY LEASE"
    },
    {
      "label": "MACHINERY LEASE",
      "value": "MACHINERY LEASE"
    },
    {
      "label": "FURNACE AREA",
      "value": "FURNACE AREA"
    },
    {
      "label": "GARDEN AREA",
      "value": "GARDEN AREA"
    },
    {
      "label": "MINERS HOMESTEAD LEASE",
      "value": "MINERS HOMESTEAD LEASE"
    },
    {
      "label": "MINERALS EXPLORATION PERMIT",
      "value": "MINERALS EXPLORATION PERMIT"
    },
    {
      "label": "PIPE TRACK WATER RIGHT",
      "value": "PIPE TRACK WATER RIGHT"
    },
    {
      "label": "CHRISTMAS ISLAND EXPLORATION LICENCE",
      "value": "CHRISTMAS ISLAND EXPLORATION LICENCE"
    },
    {
      "label": "LODE CLAIM",
      "value": "LODE CLAIM"
    },
    {
      "label": "SPECIAL LICENCE S.A.",
      "value": "SPECIAL LICENCE S.A."
    },
    {
      "label": "GENERAL PURPOSE LEASE",
      "value": "GENERAL PURPOSE LEASE"
    },
    {
      "label": "BUSINESS AREA",
      "value": "BUSINESS AREA"
    },
    {
      "label": "GOLD MINING LEASE",
      "value": "GOLD MINING LEASE"
    },
    {
      "label": "TAILINGS LEASE",
      "value": "TAILINGS LEASE"
    },
    {
      "label": "SPECIAL PROSPECTING LICENCE",
      "value": "SPECIAL PROSPECTING LICENCE"
    }
  ];

  export const defaultTenementTypes = [
    {
      "label": "MINING LEASE S.A.",
      "value": "MINING LEASE S.A."
    },
    {
      "label": "MINING LEASE",
      "value": "MINING LEASE"
    },
    {
      "label": "EXPLORATION LICENCE",
      "value": "EXPLORATION LICENCE"
    },
    {
      "label": "PROSPECTING LICENCE",
      "value": "PROSPECTING LICENCE"
    },
    {
      "label": "SPECIAL PROSPECTING LICENCE",
      "value": "SPECIAL PROSPECTING LICENCE"
    },
    {
      "label": "MISCELLANEOUS LICENCE",
      "value": "MISCELLANEOUS LICENCE"
    },
    {
      "label": "MISCELLANEOUS LICENSE S.A.",
      "value": "MISCELLANEOUS LICENSE S.A."
    },
    {
      "label": "GENERAL PURPOSE LEASE S.A.",
      "value": "GENERAL PURPOSE LEASE S.A."
    },
    {
      "label": "GENERAL PURPOSE LEASE",
      "value": "GENERAL PURPOSE LEASE"
    },
    {
      "label": "MINERAL LEASE",
      "value": "MINERAL LEASE"
    },
    {
      "label": "MINERAL LEASE S.A.",
      "value": "MINERAL LEASE S.A."
    },
    {
      "label": "GOLD MINING LEASE",
      "value": "GOLD MINING LEASE"
    },    
    {
      "label": "MINERAL CLAIM",
      "value": "MINERAL CLAIM"
    },
    {
      "label": "PROSPECTING AREA",
      "value": "PROSPECTING AREA"
    }
  ];